module.exports = __webpack_public_path__ + "img/group.020b168.webp";